//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { nodeTypes } from './config.js';
import { getValue } from '@/utils/util';
export default {
  name: 'ItemPanel',
  props: {
    graph: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      itemVisible: false,
      img: {},
    };
  },
  computed: {
    normalNodeTypes() {
      const obj = JSON.parse(JSON.stringify(nodeTypes));
      delete obj.start_node;
      Object.keys(obj).forEach((key) => {
        if (obj[key].panelType) {
          delete obj[key];
        }
      });
      return obj;
    },
    advanceNodeType() {
      const obj = JSON.parse(JSON.stringify(nodeTypes));
      delete obj.start_node;
      Object.keys(obj).forEach((key) => {
        if (obj[key].panelType !== 'advance') {
          delete obj[key];
        }
      });
      return obj;
    },
    // 边界事件
    boundaryEventTypes() {
      const obj = JSON.parse(JSON.stringify(nodeTypes));
      delete obj.start_node;
      Object.keys(obj).forEach((key) => {
        if (obj[key].panelType !== 'boundary_event') {
          delete obj[key];
        }
      });
      return obj;
    },
    // 通知渠道
    noticeChanneltypes() {
      const obj = JSON.parse(JSON.stringify(nodeTypes));
      delete obj.start_node;
      Object.keys(obj).forEach((key) => {
        if (obj[key].panelType !== 'notice_channel') {
          delete obj[key];
        }
      });
      return obj;
    },
    // 网关
    gatewayNodeTypes() {
      const obj = JSON.parse(JSON.stringify(nodeTypes));
      delete obj.start_node;
      Object.keys(obj).forEach((key) => {
        if (obj[key].panelType !== 'gateway') {
          delete obj[key];
        }
      });
      return obj;
    },
  },
  mounted() {
    const icons = [];
    this.$refs.itemPanel.querySelectorAll('.icon-tool').forEach((item) => {
      icons.push(...item.querySelectorAll('.node'));
    });
    this.$refs.itemPanel.querySelectorAll('.icon-event-tool').forEach((item) => {
      icons.push(...item.querySelectorAll('.node'));
    });

    icons.forEach((icon) => {
      const shape = icon.getAttribute('data-shape');
      const width = icon.getAttribute('width');
      const height = icon.getAttribute('height');
      const description = icon.getAttribute('description');
      // 拖放虚影用图像代替元素
      if (nodeTypes[shape].dragImg) {
        this.img[shape] = new Image();
        this.img[shape].src = nodeTypes[shape].dragImg;
      }

      icon.addEventListener('dragstart', (event) => {
        const label = icon.getAttribute('data-label');
        /* 设置拖拽传输数据 */
        event.dataTransfer.setData(
          'dragComponent',
          JSON.stringify({
            label,
            fullname: label,
            shape,
            fill: icon.getAttribute('fill'),
            width,
            height,
            description,
            default_config: nodeTypes[shape].default_config,
          }),
        );
        if (this.img[shape]) {
          event.dataTransfer.setDragImage(this.img[shape], width / 2, height / 2);
        }
        if (nodeTypes[shape]?.comboTypes?.length) {
          const { comboTypes } = nodeTypes[shape];
          this.graph.getNodes().forEach((node) => {
            const nodeType = node.get('model').type;
            if (comboTypes.includes(nodeType)) {
              this.graph.setItemState(node, 'backgroundBreathing', true);
            }
          });
        }
      });
    });

    // 阻止默认动作
    document.addEventListener(
      'drop',
      (e) => {
        e.preventDefault();
      },
      false,
    );
  },
  methods: {
    getFill(config) {
      return getValue(config, '.defaultStyle.fill') || '#fff';
    },
    getWidth(config) {
      return getValue(config, '.defaultStyle.width') || 80;
    },
    getHeight(config) {
      return getValue(config, '.defaultStyle.height') || 80;
    },
  },
};
